export const PhoneType = Object.freeze({
  WORK: 0,
  MOBILE: 1,
  FAX: 2,
  /**
   * Unsure what this is for. Discovered by Bikram but seems to be associated
   * with null phone values
   */
  BLANK: 3,
})
